<template>
  <v-container id="login" class="fill-height justify-center mgmt-login" tag="section">
    <v-row justify="center" align="center">
      <v-slide-y-transition appear>
        <base-material-card color="primary" light max-width="100%" width="420" class="px-6 py-4 mgmt-login-card">
          <template v-slot:heading>
            <div class="text-center">
              <div class="mgmt-login-badge">
                <v-icon color="white" large>mdi-shield-account</v-icon>
              </div>
              <h1 class="display-1 font-weight-bold mb-1">Management Login</h1>
              <p class="mgmt-login-subtitle mb-0" style="color: white;">Accedi alla console amministrativa</p>
            </div>
          </template>

          <v-card-text class="text-center pt-6">
            <form id="mgmt-login" name="mgmt-login" method="post" action="javascript:void(0);" v-on:submit="doLogin"
              class="mgmt-login-form">
              <v-text-field outlined dense color="secondary" v-model="email" :label="$t('email')"
                prepend-icon="mdi-email" />

              <v-text-field outlined dense class="mb-6" color="secondary" label="Password" type="password"
                v-model="password" prepend-icon="mdi-lock-outline" />

              <v-btn color="success" depressed form="mgmt-login" type="submit" :loading="loading"
                class="mx-2 v-btn--text mt-1">Login</v-btn>

              
            </form>
          </v-card-text>
          <p slot="error" class="text-danger">{{ message }}</p>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "mgmt-login",
  data() {
    return {
      email: null,
      password: null,
      message: null,
      loading: false,
    };
  },
  methods: {
    async doLogin() {
      let _ = this;
      if (!_.email || !_.password) {
        Swal.fire({
          title: "Credenziali mancanti",
          text: "Inserire username e password",
          type: "warning",
        });
        return;
      }

      _.loading = true;
      let response = await _.chiamataAxios("POST", "/mgmt/login", {
        body: { username: _.email, password: _.password },
        unauthLoginRedirect: false,
        returnDataOnError: true,
        silentError: true,
      });
      _.loading = false;

      let responseMsg = response && response.msg ? response.msg : (response && response.data && response.data.msg ? response.data.msg : null);
      let responseData = response && response.data && response.data.token ? response.data : (response && response.data && response.data.data ? response.data.data : null);

      if (responseMsg && responseMsg.esito && responseData && responseData.token) {
        localStorage.setItem("mgmtAuthToken", responseData.token);
        let redirectTo = _.$route && _.$route.query && _.$route.query.redirect
          ? _.$route.query.redirect
          : "/mgmt/console";
        _.$router.push(redirectTo);
        window.location.reload();
      } else {
        _.message = responseMsg && responseMsg.msgTxt ? responseMsg.msgTxt : "Credenziali non valide";
        Swal.fire({
          title: "Accesso negato",
          text: _.message,
          type: "error",
        });
      }
    }
  },
  mounted() {
    if (localStorage.getItem("mgmtAuthToken")) {
      this.$router.push("/mgmt/console");
    }
  },
};
</script>

<style scoped>


.mgmt-login-card {
  border-radius: 16px;
  box-shadow: 0 14px 34px rgba(28, 39, 60, 0.14);
}

.mgmt-login-badge {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  margin: 0 auto 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(92, 107, 192, 0.1);
}

.mgmt-login-subtitle {
  color: #5f6c80;
  font-size: 0.95rem;
}

.mgmt-login-form {
  max-width: 340px;
  margin: 0 auto;
}
</style>
